module.exports = __webpack_public_path__ + "static/media/loupe~LieeAxNV.d46e875f.svg";